import FullCalendarComponent from './FullCalendar.js';
export default FullCalendarComponent;
//# sourceMappingURL=index.js.map